import { FilterChoice } from '../../../common/components/SearchHeader/types/FilterChoice';
import {
  renderLocationChoice,
  renderLocationInOrNear,
} from '../../../common/components/SearchHeader/types/LocationChoice';
import { pluralize } from '../../../common/util/pluralize';
import { getSpecialtyPractitionerTerm, getSpecialtyTerm } from '../renderers';
import { SeoScenario } from '../types';

export const genericDirectory: SeoScenario = it => {
  const specialist = getSpecialtyPractitionerTerm(it);
  const specialists = pluralize(specialist);
  const location = renderLocationChoice(it.location);
  const specialty = getSpecialtyTerm(it);
  const inOrNear = renderLocationInOrNear(it.location);

  return {
    pageTitle: `Find ${specialists} ${inOrNear} ${location}`,
    metaDescription: `Find a ${specialist} ${inOrNear} ${location}. Book an appointment online or view opening hours, contact details, and more in one easy location. Finding a ${specialist} near you in ${location} has never been easier with Healthengine`,
    visualHeader: `${specialists} ${inOrNear} ${location}`,
    textContent: `Finding a ${specialist} in ${location} who's right for you and your level of health cover is easy with Healthengine.
    
    We provide comprehensive information on ${specialist} and ${specialty} clinics available in and around ${location}, including real positive customer feedback, accreditations, contact details, staff profiles, opening hours, pricing and payment info and much more.
    
    ${getFinalParagraph(it)}`,
  };
};

const getFinalParagraph = (it: FilterChoice) => {
  const location = renderLocationChoice(it.location);

  switch (it.topic?.specialist) {
    case 'GP':
      return `From emergency consultations to after hours and bulk billed appointments, we connect you with the best doctors and medical clinics in ${location} when you need it the most.`;

    case 'Dentist':
      return `From annual checkups to surgical extractions and dentures, we connect you with the best dentists and oral health care clinics in ${location} when you need it the most.`;

    case 'Physiotherapist':
      return `From injury rehabilitation and soft tissue therapy to joint manipulations, we connect you with the best physios and physiotherapy clinics in ${location} when you need it the most.`;

    case 'Chiropractor':
      return `From initial consults and back pain to musculoskeletal injuries, we connect you with the best chiros and chiropractic clinics in ${location} when you need it the most.`;

    case 'Psychologist':
      return `From depression and anxiety to couples therapy and stress management, we connect you with the best physios and physiotherapy clinics in ${location} when you need it the most.`;
    default:
      return '';
  }
};
